
import React, { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface AuthContainerProps {
  title: string;
  description: string;
  children: ReactNode;
}

const AuthContainer = ({ title, description, children }: AuthContainerProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E8F0F8] to-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <a
          href="/split-landing/index.html"
          className="inline-flex items-center text-[#3BAFDA] hover:text-[#1A6690] mb-8 transition-colors"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </a>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Card className="backdrop-blur-sm bg-white">
            <CardHeader>
              <CardTitle>{title}</CardTitle>
              <CardDescription>{description}</CardDescription>
            </CardHeader>
            <CardContent>
              {children}
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  );
};

export default AuthContainer;
